import type Owner from '@ember/owner';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class NoResultsSourcesComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.titleText = 'Connect your first data source to get started';
		this.descText =
			'Choose from our 130+ one-click integrations library to track all your company’s performance in one place, from any device.';
		this.readMoreUrl = 'https://help.databox.com/add-a-data-source';
		this.topImageLightUrl = '/images/placeholders/sources.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/sources.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-sources.png';
		this.imageHeight = 555;

		this.trackingOrigin = 'data_sources';
	}

	override get createButtonText(): string {
		return 'Connect now';
	}
}
